import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useDisclosure from 'src/hooks/utils/useDisclosure';
import { useUserContext } from 'src/context/UserProvider';
import Container from 'src/components/shared/Container';
import VideoResumeStaticScreen from 'src/components/videoAnswer/VideoResumeStaticScreen';
import VideoAnswerScreen from 'src/components/videoAnswer/VideoAnswerScreen';
import seoConfig from '../seo.json';
import Seo from 'src/components/Seo';
import { checkUserEligibilityForSecondRound } from 'shared-utils';

const VideoAnswer = () => {
	const seoInfo = seoConfig['video-resume'];
	const { user: sessionData } = useUserContext();
	const navigate = useNavigate();
	const { isOpen, onOpen, onClose } = useDisclosure();

	useEffect(() => {
		onClose();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (sessionData?._id) {
			const eligibility = checkUserEligibilityForSecondRound(sessionData);
			if (eligibility.isVideoResumeUploaded) {
				// navigate('/dashboard');
				navigate('/my-applications');
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [sessionData]);

	return (
		<>
			<Seo title={seoInfo.title} description={seoInfo.description} />
			<div className={`levelup-bg-secondary parent_dark_theme_bg_color`}>
				<div>
					<Container className="w-[90%] max-w-[1366px] pt-3 sm:w-[96%] md:pb-6">
						{!isOpen ? (
							<div className="flex justify-center">
								<VideoResumeStaticScreen onClick={onOpen} />
							</div>
						) : (
							<div className="pb-10 pt-4">
								<VideoAnswerScreen />
							</div>
						)}
					</Container>
				</div>
			</div>
		</>
	);
};

export default VideoAnswer;
